// extracted by mini-css-extract-plugin
module.exports = {"project-grid":"ProjectGrid_project-grid__Wnk_r"};